import React, { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { baseurl } from "../constant";
import Loading from "../loading";
const Dashcomponent = () => {
  const [kycstatus, setkycstatus] = useState();
  const [message, setmessage] = useState();
  const [totalDebitFund, settotalDebitFund] = useState();
  const [totalDebitFundRecord, settotalDebitFundRecord] = useState();
  const [totalCreditFund, settotalCreditFund] = useState();
  const [totalCreditFundRecord, settotalCreditFundRecord] = useState();
  const [todaySuccessPayout, settodaySuccessPayout] = useState();
  const [totalSuccessPayoutRecord, settotalSuccessPayoutRecord] = useState();
  const [totalPendingPayout, settotalPendingPayout] = useState();
  const [totalPendingPayoutRecord, settotalPendingPayoutRecord] = useState();
  const [totalFailedPayout, totalFailedPayoutRecord] = useState();
  const [todayOpeningBal, settodayOpeningBal] = useState();
  const [todayPurchaseBal, settodayPurchaseBal] = useState();
  const [todayPurchaseBalRecord, settodayPurchaseBalRecord] = useState();
  const [todaySuccessPayout1, settodaySuccessPayout1] = useState();
  const [todayPendingPayout, settodayPendingPayout] = useState();
  const [todayPendingPayoutRecord, settodayPendingPayoutRecord] = useState();
  const [todayRefundPayout, settodayRefundPayout] = useState();
  const [todayRefundPayoutRecord, settodayRefundPayoutRecord] = useState();
  const [totalFailedPayoutRecord1, settotalFailedPayoutRecord1] = useState();
  const [todaySuccessPayoutRecord, settodaySuccessPayoutRecord] = useState();
  const [totalSuccessPayout, settotalSuccessPayout] = useState();
  const [loading, setloading] = useState(false);
  const [data, setdata] = useState();

  const formattedNumber = (number) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(number);

  const token = localStorage.getItem("authToken");
  useEffect(() => {
    // const interval = setInterval(() => {
    //   dataresult(); // Your function here
    // }, 1000); // 1000ms = 1 second

    // // Cleanup the interval on component unmount
    // return () => clearInterval(interval);
    dataresult();
  }, []);
  const dataresult = async () => {
    setloading(true);
    const result = await axios.post(baseurl + "dashboardAuth", {
      token: token,
    });
    setdata(result.data);
    settotalDebitFund(result.data.totalDebitFund);
    settotalDebitFundRecord(result.data.totalDebitFundRecord);
    settotalCreditFund(result.data.totalCreditFund);
    settotalCreditFundRecord(result.data.totalCreditFundRecord);
    settodaySuccessPayout(result.data.todaySuccessPayout);
    settotalSuccessPayoutRecord(result.data.totalSuccessPayoutRecord);
    settotalPendingPayout(result.data.totalPendingPayout);
    settotalPendingPayoutRecord(result.data.totalPendingPayoutRecord);
    totalFailedPayoutRecord(result.data.totalFailedPayout);
    settodayOpeningBal(result.data.todayOpeningBal);
    settodayPurchaseBal(result.data.todayPurchaseBal);
    settodayPurchaseBalRecord(result.data.todayPurchaseBalRecord);
    settodaySuccessPayout1(result.data.todaySuccessPayout1);
    settodayPendingPayout(result.data.todayPendingPayout);
    settodayPendingPayoutRecord(result.data.todayPendingPayoutRecord);
    settodayRefundPayout(result.data.todayRefundPayout);
    settodayRefundPayoutRecord(result.data.todayRefundPayoutRecord);
    settotalFailedPayoutRecord1(result.data.todayRefundPayoutRecord);
    settodaySuccessPayoutRecord(result.data.todaySuccessPayoutRecord);
    settotalSuccessPayout(result.data.totalSuccessPayout);

    setkycstatus(result.data.kycstatus);
    setloading(false);
  };

  return (
    <>
      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-md-12">
              {kycstatus == 0 && (
                <div className="alert alert-danger alert-dismissable">
                  Kindly complete your KYC to use the services.{" "}
                  <a
                    href="https://www.payol.in/portal/kyc"
                    className="text-primary"
                  >
                    {" "}
                    Do Kyc Now
                  </a>
                </div>
              )}
              {kycstatus == 1 && (
                <div
                  className="alert alert-danger alert-dismissable"
                  style={{ color: "orange" }}
                >
                  Kyc Is Pending Please Wait.
                  <a
                    href="https://www.payol.in/portal/kyc"
                    className="text-primary"
                  ></a>
                </div>
              )}

              {kycstatus == 3 && (
                <div
                  className="alert alert-danger alert-dismissable"
                  style={{ color: "red" }}
                >
                  Your Kyc Was Rejected Please Do Again .{" "}
                  <a href="{site_url}portal/kyc" class="text-primary">
                    {" "}
                    Do Kyc Again
                  </a>
                </div>
              )}
              <h1 className="h3 mb-0 text-gray-800">Welcome to API Panel</h1>
            </div>
          </div>
          <div className="dash_card card shadow">
            <div className="card_heading">
              <h1 className="h3 mb-0 text-gray-800">Total Summary</h1>
            </div>
            <div className="row card_row_col">
              <div className="col service_col">
                <div className="card_body_dash">
                  <h5>
                    <a href="#">TOTAL DEBIT FUND</a>
                  </h5>
                  <h3>
                    {formattedNumber(totalDebitFund)}/{totalDebitFundRecord}
                  </h3>
                </div>
              </div>
              <div className="col service_col">
                <div className="card_body_dash">
                  <h5>
                    <a href="#">TOTAL CREDIT FUND</a>
                  </h5>
                  <h3>
                    {formattedNumber(totalCreditFund)}/{totalCreditFundRecord}
                  </h3>
                </div>
              </div>
              <div className="col service_col">
                <div className="card_body_dash">
                  <h5>
                    <a href="#">TOTAL SUCCESS PAYOUT</a>
                  </h5>
                  <h3>
                    {formattedNumber(totalSuccessPayout)}/
                    {totalSuccessPayoutRecord}
                  </h3>
                </div>
              </div>
              <div className="col service_col">
                <div className="card_body_dash">
                  <h5>
                    <a href="#">TOTAL PENDING PAYOUT</a>
                  </h5>
                  <h3>
                    {formattedNumber(totalPendingPayout)}/
                    {totalPendingPayoutRecord}
                  </h3>
                </div>
              </div>
              <div className="col service_col">
                <div className="card_body_dash">
                  <h5>
                    <a href="#">TOTAL FAILED PAYOUT</a>
                  </h5>
                  <h3>
                    {formattedNumber(totalFailedPayout)}/
                    {totalFailedPayoutRecord1}
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div className="dash_card card shadow">
            <div className="card_heading">
              <h1 className="h3 mb-0 text-gray-800">Today Summary</h1>
            </div>
            <div className="row card_row_col">
              <div className="col service_col">
                <div className="card_body_dash">
                  <h5>
                    <a href="#">OPENING BALANCE</a>
                  </h5>
                  <h3>{formattedNumber(todayOpeningBal)}</h3>
                </div>
              </div>
              <div className="col service_col">
                <div className="card_body_dash">
                  <h5>
                    <a href="#">PURCHASE BALANCE</a>
                  </h5>
                  <h3>
                    {formattedNumber(todayPurchaseBal)}/{todayPurchaseBalRecord}
                  </h3>
                </div>
              </div>
              <div className="col service_col">
                <div className="card_body_dash">
                  <h5>
                    <a href="https://www.payol.in/portal/report/newPayoutReport/3">
                      SUCCESS PAYOUT
                    </a>
                  </h5>
                  <h3>
                    {formattedNumber(todaySuccessPayout)}/
                    {todaySuccessPayoutRecord}
                  </h3>
                </div>
              </div>
              <div className="col service_col">
                <div className="card_body_dash">
                  <h5>
                    <a href="https://www.payol.in/portal/report/newPayoutReport/2">
                      PENDING PAYOUT
                    </a>
                  </h5>
                  <h3>
                    {formattedNumber(todayPendingPayout)}/
                    {todayPendingPayoutRecord}
                  </h3>
                </div>
              </div>
              <div className="col service_col">
                <div className="card_body_dash">
                  <h5>
                    <a href="#">REFUND PAYOUT</a>
                  </h5>
                  <h3>
                    {formattedNumber(todayRefundPayout)}/
                    {todayRefundPayoutRecord}
                  </h3>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="dash_card card shadow">
          <div className="card_heading">
           <h1 className="h3 mb-0 text-gray-800">Today History</h1>
         </div>
        <div className="row card_row_col">
        <div className="col service_col">
        <div className="card_body_dash">
         <h5><a href="#">TOTAL SUCCESS</a></h5>  
         <h3>₹ 433.00 / 3</h3> 
        </div>  
       </div> 
       <div className="col service_col">
        <div className="card_body_dash">
         <h5><a href="#">TOTAL PENDING</a></h5>  
         <h3>₹ 433.00 / 3</h3> 
        </div>  
       </div>
       <div className="col service_col">
        <div className="card_body_dash">
         <h5><a href="#">TOTAL SUCCESS</a></h5>  
         <h3>₹ 433.00 / 3</h3> 
        </div>  
       </div>
       <div className="col service_col">
        <div className="card_body_dash">
         <h5><a href="#">TOTAL SUCCESS</a></h5>  
         <h3>₹ 433.00 / 3</h3> 
        </div>  
       </div> 
       <div className="col service_col">
        <div className="card_body_dash">
         <h5><a href="#">TOTAL Failed</a></h5>  
         <h3>₹ 433.00 / 3</h3> 
        </div>  
       </div> 
        </div>

         </div>  */}
        </div>
      )}
    </>
  );
};

export default Dashcomponent;
